import InputConfig from '../InputConfig';
//mui imports====
import { Box } from '@mui/system';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Popper from '@mui/material/Popper';
import useStyles from './styles';
//===============

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

//keyList is the list of keys to select from, [ NOTE : keyData is the absolute key from rawConfig ], valueType is the type of value input

const ValueInput = ({
	keyData,
	label,
	keyValue, // This is a mandatory field to be added, key value must be specified by user
	object, // This props can take rawConfig or directObject as value and can handle both the cases of rawConfig and directValue
	updateObject, // This is a callback function which takes the updated object and updated in rawConfig, it can be used to update rawConfig or directValue input
	valueType,
	generateLabel = null,
	isObjectEditor = true,
	isAutoCompleteRequired = false, // This props can be used when required to use AutoComplete Component
	options,
	containerStyle
}) => {
	const classes = useStyles();

	/**
	 * @name deleteKey
	 * @description This function deletes a key value pair from the intial object, with two scenarios if isObjectEditor is true or false
	 * 1. true : it deletes key value pair from object with the rawConfig functionality and passes value to call back function
	 * 2. false : it deletes the key value from object value directly and passes it to the callback function
	 */
	const deleteKey = () => {
		if (!keyValue) {
			alert('Country code is not present, please specify a country code');
			return;
		}
		const clonedObj = structuredClone(object);
		if (isObjectEditor) {
			delete clonedObj[keyData + '.' + keyValue];
		} else {
			delete clonedObj[keyValue];
		}
		updateObject(clonedObj);
	};

	/**
	 * @name updateKey
	 * @description This function updates a new key value pair to the intial object for InputConfig Component with direct value functionality
	 * @param {string} updatedValue this is the updated value returned from InputConfig component
	 */
	const updateKey = (updatedValue) => {
		if (!keyValue) {
			alert('Country code is not present, please specify a country code');
			return;
		}
		if (valueType === 'number') updatedValue = Number(updatedValue);

		const clonedObj = structuredClone(object);
		clonedObj[keyValue] = updatedValue;
		updateObject(clonedObj);
	};

	/**
	 * @name handleInputChange
	 * @description  This function adds a new key value pair to the intial object in AutoComplete Component, with two scenarios if isObjectEditor is true or false
	 * 1. true : it updates key value pair in the object with the rawConfig functionality and passes value to call back function
	 * 2. false : it updates the object value directly and passes it to the callback function
	 * @param {object} updatedObject this is the updated object returned from Autocomplete component which can be used to extract updated floor value
	 */
	const handleInputChange = (event, updatedObject) => {
		if (!keyValue) {
			alert('Country code is not present, please specify a country code');
			return;
		}
		const clonedObj = structuredClone(object);
		if (isObjectEditor) {
			if (object && keyData && keyValue) {
				clonedObj[keyData + '.' + keyValue] = updatedObject ? updatedObject?.value : '';
			}
		} else {
			clonedObj[keyValue] = updatedObject ? updatedObject?.value : '';
		}
		updateObject(clonedObj);
	};

	/**
	 * @name getInputValue
	 * @description The function returns the floor value countywise present in the intial object to Autocomplete component, with two scenarios if isObjectEditor is true or false
	 * 1. true : it return the floor  value pair in the object with the rawConfig functionality
	 * 2. false : it returns floor value directly from initial object
	 * @return {string} it returns floor value for the country code present in object
	 */
	const getInputValue = () => {
		if (!keyValue) {
			alert('Country code is not present, please specify a country code');
			return;
		}
		if (isObjectEditor) {
			if (object && keyData && keyValue) {
				return object[keyData + '.' + keyValue];
			}
		} else {
			return object[keyValue] || '';
		}
	};

	const customStyles = {
		transition: 'none',
		width: '250px'
	};

	return (
		<Box style={containerStyle}>
			<Box>
				<FormControl>
					<Select value={keyValue} label={label} MenuProps={MenuProps} style={{width : '165px'}}>
						<MenuItem value={keyValue}>{generateLabel ? generateLabel(keyValue) : keyValue}</MenuItem>
					</Select>
				</FormControl>
			</Box>
			<Box>
				{/* AutoComplete Component will be disaplyed if isAutoCompleteRequired flag is true  */}
				{isAutoCompleteRequired && (
					<Autocomplete
						value={getInputValue()}
						onChange={handleInputChange}
						id="number-input"
						freeSolo={false}
						options={options}
						sx={{ width: 250 }}
						style={{ margin: '1rem 0' }}
						disablePortal={false}
						PopperComponent={(props) => <Popper {...props} style={customStyles} />}
						renderInput={(params) => <TextField {...params} label="Select" variant="outlined" />}
					/>
				)}

				{/* InputConfig component with rawConfig updating functionality will be displayed, if isAutoCompleteRequired flag is false and isObjectEditor is true */}
				{!isAutoCompleteRequired && isObjectEditor && (
					<InputConfig
						inputType={valueType}
						inputStyles={{ width: '100%', margin: '1rem 0' }}
						keyData={keyData + '.' + keyValue}
						object={object}
						updateObject={updateObject}
					/>
				)}
				{/* InputConfig component with direct value updating functionality will be displayed, if isAutoCompleteRequired flag is false and isObjectEditor is false */}
				{!isAutoCompleteRequired && !isObjectEditor && (
					<InputConfig
						inputType={valueType}
						inputStyles={{ width: '100%', margin: '1rem 0' }}
						isObjectEditor={false}
						directValue={object[keyValue] || ''}
						updateDirectValue={(value) => {
							updateKey(value);
						}}
					/>
				)}
			</Box>

			<DeleteOutlinedIcon color="primary" className={classes.icon} onClick={deleteKey} />
		</Box>
	);
};
export default ValueInput;
